export const environment = {
  domainName: "ehrconnectorsvc-canary.teams.microsoft",
  basePath: "/api/cerner/graphql/v1",
  cernerEnv: ["test", "prod"],
  appName: "CernerEHRConnector",
  appEnv: "canary",
  isRegionalServiceDisabled: true,
};
